export default {
  steps: {
    instruction: 'Anweisung',
    on: 'Auf',
    step: 'Schritt',
    gotoStep: 'Schritt auf Karte anzeigen'
  }
}
